import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import { StandardSiteFooterFragment } from '../../../graphql-types';
import Footer from './Footer';

interface FooterProps {
  isCareersPage: boolean;
}

const StandardFooterAdapter: React.FC<FooterProps> = ({ isCareersPage }) => {
  const result = useStaticQuery<StandardSiteFooterFragment>(graphql`
    query {
      ...StandardSiteFooter
    }
  `);

  const data = result?.contentfulSiteData;
  if (!data) {
    return null;
  }

  return <Footer data={data} isCareersPage={isCareersPage} />;
};

export default StandardFooterAdapter;
